import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FeaturesRoutingEnum } from '@features/features-routing.enum';
import { Publication } from '@models/company/publication';
import { CompanyRoutingEnum } from '@routing/company/company-routing.enum';
import { buildPath, buildUrl } from '@wizbii/angular-utilities';
import { str as stringHash } from 'adler-32';

@Component({
  selector: 'company-publication',
  templateUrl: './publication.component.html',
  styleUrls: ['./publication.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicationComponent implements OnInit {
  static COLORS = ['#8782ff', '#45cfff', '#3df9c6', '#e8a3f4', '#ff5c60'];

  @Input() model: Publication;
  @Input() companyName = true;

  companyUrl: string;
  publicationImage: string;

  ngOnInit(): void {
    this.companyUrl = buildUrl(buildPath(FeaturesRoutingEnum.Company, CompanyRoutingEnum.Root), {
      companyId: this.model.companyId,
    });

    if (this.model.imageFileUrl) {
      this.publicationImage = `url(${this.model.imageFileUrl})`;
    } else {
      const hash = Math.abs(stringHash(this.model.companyId || this.model.companyName));
      this.publicationImage = PublicationComponent.COLORS[hash % PublicationComponent.COLORS.length];
    }
  }
}
